var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import services from '../../services';
import * as actionTypes from './constants';
import { storeSelectedOrganizationId, setRecentlySelectedOrgIds, } from './utils';
import storageService from '../../utils/storageService';
import toast from '../../components/Toast';
import { SET_OPEN_APP } from './constants';
import { useLocalStorage } from '../../utils/hooks/services';
import { resetOrgStatusSummery } from 'store/orgStatusSummery/actions';
var AuthService = services.AuthService, AppService = services.AppService, DatasetService = services.DatasetService, PolicyService = services.PolicyService, TermService = services.TermService, OrganizationService = services.OrganizationService, TemplatesService = services.TemplatesService, PlatformService = services.PlatformService;
export var updateSingleApp = function (updatedApp) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var app, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.LOAD_APPS });
                return [4 /*yield*/, AppService.updateApp(updatedApp)];
            case 1:
                app = (_a.sent()).object;
                if (app) {
                    dispatch({ type: actionTypes.LOAD_APPS_EMPTY_SUCCESS, app: app });
                    return [2 /*return*/, app];
                }
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                console.error(e_1);
                return [3 /*break*/, 3];
            case 3:
                dispatch({ type: actionTypes.LOAD_APPS_FAILED });
                return [2 /*return*/, null];
        }
    });
}); }; };
export var createAppTemplate = function (template) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var newTemplate, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.CREATE_APP_TEMPLATE });
                return [4 /*yield*/, TemplatesService.createTemplate(template)];
            case 1:
                newTemplate = (_a.sent()).object;
                toast.success('Template created');
                dispatch({ type: actionTypes.CREATE_APP_TEMPLATE_SUCCESS, newTemplate: newTemplate });
                return [2 /*return*/, true];
            case 2:
                e_2 = _a.sent();
                console.error(e_2);
                toast.error('An error occurred while creating the template');
                dispatch({ type: actionTypes.CREATE_APP_TEMPLATE_FAILED });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var updateAppTemplate = function (template, templateId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedTemplate, e_3;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.UPDATE_APP_TEMPLATE });
                return [4 /*yield*/, TemplatesService.updateTemplate(template, templateId)];
            case 1:
                updatedTemplate = (_b.sent()).object;
                if ((_a = template === null || template === void 0 ? void 0 : template.app_template) === null || _a === void 0 ? void 0 : _a.type) {
                    toast.success('Template updated!');
                }
                else {
                    toast.success('Template unpublished!');
                }
                dispatch({
                    type: actionTypes.UPDATE_APP_TEMPLATE_SUCCESS,
                    updatedTemplate: updatedTemplate,
                });
                return [2 /*return*/, true];
            case 2:
                e_3 = _b.sent();
                toast.error('An error occurred while updating the template');
                dispatch({ type: actionTypes.UPDATE_APP_TEMPLATE_FAILED });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getTemplateData = function (templateId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var templateData, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.GET_TEMPLATE_DATA });
                if (!templateId) {
                    return [2 /*return*/, dispatch({ type: actionTypes.GET_TEMPLATE_DATA_FAILURE })];
                }
                return [4 /*yield*/, TemplatesService.getTemplateData(templateId)];
            case 1:
                templateData = (_a.sent()).object;
                return [2 /*return*/, dispatch({
                        type: actionTypes.GET_TEMPLATE_DATA_SUCCESS,
                        templateData: templateData,
                    })];
            case 2:
                err_1 = _a.sent();
                return [2 /*return*/, dispatch({ type: actionTypes.GET_TEMPLATE_DATA_FAILURE, err: err_1 })];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var clearMedia = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, TemplatesService.clearMedia(appId)];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2:
                err_2 = _a.sent();
                return [2 /*return*/, dispatch({ type: actionTypes.GET_TEMPLATE_DATA_FAILURE, err: err_2 })];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getTemplateEnvironmentVariables = function (templateId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var objects, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.GET_TEMPLATE_DATA });
                if (!templateId) {
                    return [2 /*return*/, dispatch({ type: actionTypes.GET_TEMPLATE_DATA_FAILURE })];
                }
                return [4 /*yield*/, TemplatesService.getTemplateEnvData(templateId)];
            case 1:
                objects = (_a.sent()).objects;
                return [2 /*return*/, objects];
            case 2:
                err_3 = _a.sent();
                return [2 /*return*/, dispatch({ type: actionTypes.GET_TEMPLATE_DATA_FAILURE, err: err_3 })];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getTemplates = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var templates, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.GET_APP_TEMPLATES });
                return [4 /*yield*/, TemplatesService.getAllTemplates()];
            case 1:
                templates = (_a.sent()).objects;
                dispatch({ type: actionTypes.GET_APP_TEMPLATES_SUCCESS, templates: templates });
                return [3 /*break*/, 3];
            case 2:
                err_4 = _a.sent();
                dispatch({ type: actionTypes.GET_APP_TEMPLATES_FAILURE, err: err_4 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deleteTemplate = function (templateId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.DELETE_APP_TEMPLATES });
                return [4 /*yield*/, TemplatesService.deleteTemplate(templateId)];
            case 1:
                _a.sent();
                getTemplateData();
                toast.success('Template deleted');
                dispatch({ type: actionTypes.DELETE_APP_TEMPLATES_SUCCESS, templateId: templateId });
                return [3 /*break*/, 3];
            case 2:
                err_5 = _a.sent();
                toast.error('An error occurred while deleting the template');
                dispatch({ type: actionTypes.DELETE_APP_TEMPLATES_FAILURE, err: err_5 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getCategories = function (orgId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var categories, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({ type: actionTypes.GET_TEMPLATE_CATEGORIES });
                if (!orgId) return [3 /*break*/, 2];
                return [4 /*yield*/, OrganizationService.getOrganizationCategories(orgId)];
            case 1:
                categories = (_a.sent()).objects;
                _a.label = 2;
            case 2:
                dispatch({ type: actionTypes.GET_TEMPLATE_CATEGORIES_SUCCESS, categories: categories });
                return [2 /*return*/, categories];
            case 3:
                err_6 = _a.sent();
                dispatch({ type: actionTypes.GET_TEMPLATE_CATEGORIES_FAILED, err: err_6 });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var createCategory = function (orgId, category) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var addedCategory, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.CREATE_TEMPLATE_CATEGORY });
                return [4 /*yield*/, OrganizationService.addOrganizationCategory(orgId, category)];
            case 1:
                addedCategory = (_a.sent()).object;
                toast.success('Category created');
                dispatch({
                    type: actionTypes.CREATE_TEMPLATE_CATEGORY_SUCCESS,
                    addedCategory: addedCategory,
                });
                return [3 /*break*/, 3];
            case 2:
                e_4 = _a.sent();
                toast.error('An error occurred while creating the category');
                dispatch({ type: actionTypes.CREATE_TEMPLATE_CATEGORY_FAILED });
                console.error(e_4);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var updateCategory = function (orgId, category) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var updateData, updatedCategory, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.UPDATE_TEMPLATE_CATEGORY });
                updateData = {
                    label: category.label,
                    global: !!category.global,
                    organization: category.organization,
                };
                return [4 /*yield*/, OrganizationService.updateOrganizationCategory(orgId, updateData, category.id)];
            case 1:
                updatedCategory = (_a.sent()).object;
                toast.success('Category updated');
                dispatch({
                    type: actionTypes.UPDATE_TEMPLATE_CATEGORY_SUCCESS,
                    updatedCategory: updatedCategory,
                });
                return [3 /*break*/, 3];
            case 2:
                e_5 = _a.sent();
                toast.error('An error occurred while updating the category');
                dispatch({ type: actionTypes.UPDATE_TEMPLATE_CATEGORY_FAILED });
                console.error(e_5);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var deleteCategory = function (orgId, categoryId, templateId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.DELETE_TEMPLATE_CATEGORY });
                return [4 /*yield*/, OrganizationService.deleteOrganizationCategory(orgId, categoryId, templateId)];
            case 1:
                _a.sent();
                toast.success('Category deleted');
                dispatch({
                    type: actionTypes.DELETE_TEMPLATE_CATEGORY_SUCCESS,
                    categoryId: categoryId,
                });
                return [3 /*break*/, 3];
            case 2:
                e_6 = _a.sent();
                if ((e_6 === null || e_6 === void 0 ? void 0 : e_6.status) === 400) {
                    toast.error("This category is used in multiple templates, so you can't delete.");
                }
                else {
                    toast.error('An error occurred while deleting the category');
                }
                dispatch({ type: actionTypes.DELETE_TEMPLATE_CATEGORY_FAILED });
                console.error(e_6);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var selectOrganization = function (organizationId, userId) { return function (dispatch) {
    if (organizationId) {
        dispatch({
            type: actionTypes.SELECT_ORGANIZATION,
            organizationId: organizationId,
        });
        storeSelectedOrganizationId(organizationId);
        userId && setRecentlySelectedOrgIds(organizationId, userId);
    }
}; };
export var logout = function (path, navigate) { return function (dispatch) {
    storageService.removeItem('token');
    dispatch({ type: actionTypes.LOGOUT });
    dispatch({ type: 'REMOVE_USER_DATA_WHEN_LOGOUT' });
    navigate(path);
    dispatch(resetOrgStatusSummery());
}; };
export var secondarySideBarChange = function (secondaryMenuState) { return function (dispatch) {
    dispatch({
        type: actionTypes.SECONDARY_SIDEBAR_STATE,
        secondaryMenuState: secondaryMenuState,
    });
}; };
export var mainSideBarChange = function (mainMenuState) { return function (dispatch) {
    dispatch({
        type: actionTypes.MAIN_SIDEBAR_STATE,
        mainMenuState: mainMenuState,
    });
}; };
export var updateDashboard = function (dashboard) { return function (dispatch) {
    // BEGIN Temporary code to persist dashboard layout due to lack of backend service
    storageService.setItem('localDashboard', JSON.stringify(dashboard));
    // END
    dispatch({
        type: actionTypes.UPDATE_DASHBOARD,
        dashboard: dashboard,
    });
}; };
export var startApiCalls = function (isLoggedIn) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isLoggedIn) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Promise.all([
                        dispatch(loadUserProfile()),
                        dispatch(loadUserGroups()),
                        dispatch(loadLatestPolicy()),
                        dispatch(loadLatestTerm()),
                    ])];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                e_7 = _a.sent();
                console.error(e_7);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var initializeData = function (isLoggedIn, urlParam, userId) {
    if (urlParam === void 0) { urlParam = ''; }
    if (userId === void 0) { userId = ''; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var organizations, storedOrgId_1, storedOrgIsValid, orgId, urlBlocks, sideBarState, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLoggedIn) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(loadUserOrganizations())];
                case 1:
                    organizations = _a.sent();
                    storedOrgId_1 = storageService.getItem('selectedOrganizationId');
                    storedOrgIsValid = storedOrgId_1 === 'shared' ||
                        (organizations === null || organizations === void 0 ? void 0 : organizations.some(function (org) { return org.id === storedOrgId_1; }));
                    if (!storedOrgId_1 || !storedOrgIsValid) {
                        orgId = void 0;
                        if (urlParam && urlParam.includes('/organizations/')) {
                            urlBlocks = urlParam.split('/');
                            if (urlBlocks.length > 2) {
                                orgId = urlBlocks[2];
                            }
                        }
                        if (!orgId && (organizations === null || organizations === void 0 ? void 0 : organizations.length) > 0) {
                            orgId = organizations[0].id;
                        }
                        else if (!orgId)
                            orgId = 'shared';
                        dispatch(selectOrganization(orgId, userId));
                    }
                    else {
                        dispatch(selectOrganization(storedOrgId_1, userId));
                    }
                    sideBarState = useLocalStorage('sidebar_open');
                    sideBarState.setValue('true');
                    _a.label = 2;
                case 2:
                    token = storageService.getItem('token');
                    /* Added this here eventhought isLoggedIn is passed coz
                    when tolken expires this causes an error as this function takes time to execute
                    so initialized set to true after logging out
                    */
                    token && dispatch({ type: actionTypes.SIGNAL_ROOT_INITIALIZED });
                    return [2 /*return*/];
            }
        });
    }); };
};
export var loadApps = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, meta, apps, orderdApps, ex_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                dispatch({ type: actionTypes.LOAD_APPS });
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, AppService.getAppPublishList(storageService.getItem('selectedOrganizationId'))];
            case 2:
                _a = _b.sent(), meta = _a.meta, apps = _a.objects;
                orderdApps = __spreadArray(__spreadArray([], (apps || []).filter(function (app) { return app.is_favourite === true; }), true), (apps || []).filter(function (app) { return app.is_favourite === false; }), true);
                if (apps) {
                    return [2 /*return*/, dispatch({
                            type: actionTypes.LOAD_APPS_SUCCESS,
                            apps: orderdApps,
                            meta: meta,
                        })];
                }
                return [2 /*return*/, dispatch({ type: actionTypes.LOAD_APPS_FAILED })];
            case 3:
                ex_1 = _b.sent();
                return [2 /*return*/, dispatch({ type: actionTypes.LOAD_APPS_FAILED })];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var loadAllOrgApps = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var apps, ex_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: actionTypes.LOAD_ALL_ORG_APPS });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, AppService.getAllOrgAppsList()];
            case 2:
                apps = (_a.sent()).objects;
                if (apps) {
                    return [2 /*return*/, dispatch({
                            type: actionTypes.LOAD_ALL_ORG_APPS_SUCCESS,
                            apps: apps,
                        })];
                }
                return [2 /*return*/, dispatch({ type: actionTypes.LOAD_ALL_ORG_APPS_FAILED })];
            case 3:
                ex_2 = _a.sent();
                return [2 /*return*/, dispatch({ type: actionTypes.LOAD_ALL_ORG_APPS_FAILED })];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var loadOrgApps = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var apps, ex_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: actionTypes.LOAD_ORG_APPS });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, AppService.getAppPublishList(storageService.getItem('selectedOrganizationId'))];
            case 2:
                apps = (_a.sent()).objects;
                if (apps) {
                    return [2 /*return*/, dispatch({
                            type: actionTypes.LOAD_ORG_APPS_SUCCESS,
                            apps: apps,
                        })];
                }
                return [2 /*return*/, dispatch({ type: actionTypes.LOAD_ORG_APPS_FAILED })];
            case 3:
                ex_3 = _a.sent();
                return [2 /*return*/, dispatch({ type: actionTypes.LOAD_ORG_APPS_FAILED })];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var checkUsage = function (datasetId, appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, object, objects, ex_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                dispatch({ type: actionTypes.LOAD_USAGE_APP });
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, DatasetService.getUsage(datasetId, appId)];
            case 2:
                _a = _b.sent(), object = _a.object, objects = _a.objects;
                return [2 /*return*/, dispatch({
                        type: actionTypes.LOAD_USAGE_APP_SUCCESS,
                        appsDetails: (object === null || object === void 0 ? void 0 : object.patches) || (object === null || object === void 0 ? void 0 : object.views) ? [] : objects,
                        patchesDetails: object === null || object === void 0 ? void 0 : object.patches,
                        viewsDetails: object === null || object === void 0 ? void 0 : object.views,
                    })];
            case 3:
                ex_4 = _b.sent();
                return [2 /*return*/, dispatch({ type: actionTypes.LOAD_USAGE_APP_FAILED })];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var createApp = function (name, organizationId, template, template_with_data, navigate) {
    if (template === void 0) { template = 'blank'; }
    if (template_with_data === void 0) { template_with_data = false; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var app, ex_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: actionTypes.CREATE_APP });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, AppService.createApp(name, organizationId, template, template_with_data, navigate)];
                case 2:
                    app = (_a.sent()).object;
                    if (app) {
                        dispatch(loadApps());
                        dispatch({ type: actionTypes.CREATE_APP_SUCCESS, app: app });
                        return [2 /*return*/, navigate("/organizations/".concat(organizationId, "/apps/").concat(app.id, "/overview"))];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    ex_5 = _a.sent();
                    console.error("Failed to create app: ".concat(name));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, dispatch({ type: actionTypes.CREATE_APP_FAILED })];
            }
        });
    }); };
};
export var loadUserOrganizations = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var token, organizationId, organizations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = storageService.getItem('token');
                organizationId = storageService.getItem('selectedOrganizationId');
                if (!token) return [3 /*break*/, 2];
                return [4 /*yield*/, OrganizationService.listOrganizations()];
            case 1:
                organizations = (_a.sent()).objects;
                dispatch({
                    type: actionTypes.LOAD_USER_ORGANIZATIONS,
                    organizations: organizations,
                    organizationId: organizationId,
                });
                return [2 /*return*/, organizations];
            case 2: return [2 /*return*/, []];
        }
    });
}); }; };
export var listOrganizationswithAppWritePerm = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var organizations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, OrganizationService.listOrganizationswithAppWritePerm()];
            case 1:
                organizations = (_a.sent()).objects;
                dispatch({
                    type: actionTypes.LOAD_APP_WRITE_ORGANIZATIONS,
                    organizations: organizations,
                });
                return [2 /*return*/, organizations];
        }
    });
}); }; };
export var loadUserProfile = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var userProfile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, AuthService.getUserProfile()];
            case 1:
                userProfile = (_a.sent()).object;
                if (userProfile) {
                    dispatch({
                        type: actionTypes.LOAD_USER_PROFILE,
                        me: userProfile,
                    });
                }
                return [2 /*return*/];
        }
    });
}); }; };
export var loadLatestTerm = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var latestTerm;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, TermService.termLatest()];
            case 1:
                latestTerm = (_a.sent()).object;
                dispatch({
                    type: actionTypes.LOAD_LATEST_TERM,
                    latestTerm: latestTerm,
                });
                return [2 /*return*/];
        }
    });
}); }; };
export var acceptLatestTerm = function (termId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, TermService.termLatestAccept(termId)];
            case 1:
                _a.sent();
                dispatch(loadLatestTerm());
                return [2 /*return*/];
        }
    });
}); }; };
export var loadLatestPolicy = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var latestPolicy;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, PolicyService.policyLatest()];
            case 1:
                latestPolicy = (_a.sent()).object;
                dispatch({
                    type: actionTypes.LOAD_LATEST_POLICY,
                    latestPolicy: latestPolicy,
                });
                return [2 /*return*/];
        }
    });
}); }; };
export var acceptLatestPolicy = function (policyId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, PolicyService.policyLatestAccept(policyId)];
            case 1:
                _a.sent();
                dispatch(loadLatestPolicy());
                return [2 /*return*/];
        }
    });
}); }; };
export var loadUserGroups = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var groups;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, AuthService.getUserGroups()];
            case 1:
                groups = (_a.sent()).objects;
                if (groups) {
                    dispatch({
                        type: actionTypes.LOAD_USER_GROUPS,
                        groups: groups,
                    });
                }
                return [2 /*return*/];
        }
    });
}); }; };
export var login = function (email, password, code, urlParam, navigate) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var result, require2FA, token, _a, _b, err_7;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 9, , 10]);
                dispatch({ type: actionTypes.LOGIN_REQUEST });
                if (!(email && password)) return [3 /*break*/, 7];
                return [4 /*yield*/, AuthService.exchangeToken(email, password, code)];
            case 1:
                result = (_c.sent()).object;
                if (!result) return [3 /*break*/, 5];
                require2FA = result.require2FA, token = result.token;
                if (require2FA) {
                    dispatch({ type: actionTypes.LOGIN_REQUEST_2FA });
                }
                if (!token) return [3 /*break*/, 4];
                storageService.setItem('token', token); // persist token in localstorage
                dispatch({
                    type: actionTypes.LOGIN_SUCCESS,
                    email: email,
                });
                _a = dispatch;
                return [4 /*yield*/, startApiCalls(true)];
            case 2:
                _a.apply(void 0, [_c.sent()]);
                _b = dispatch;
                return [4 /*yield*/, initializeData(true, urlParam)];
            case 3:
                _b.apply(void 0, [_c.sent()]);
                navigate(urlParam && !urlParam.includes('login') ? urlParam : '/', {
                    replace: true,
                });
                _c.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                dispatch({ type: actionTypes.LOGIN_FAILED });
                _c.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                dispatch({ type: actionTypes.LOGIN_FAILED });
                _c.label = 8;
            case 8: return [3 /*break*/, 10];
            case 9:
                err_7 = _c.sent();
                dispatch({ type: actionTypes.LOGIN_FAILED });
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}); }; };
export var signup = function (user) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var newUser, noInValidFields;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newUser = {
                    email: '',
                    password: '',
                };
                newUser = Object.assign(newUser, user);
                noInValidFields = true;
                if (!noInValidFields) return [3 /*break*/, 2];
                return [4 /*yield*/, AuthService.signup(newUser.email, newUser.password)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                dispatch({ type: actionTypes.SIGNUP_FAILED });
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var sendResetPasswordLink = function (email) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.RESET_PASSWORD_REQUEST });
                return [4 /*yield*/, AuthService.sendResetEmail({ appId: null, email: email })];
            case 1:
                _a.sent();
                dispatch({ type: actionTypes.RESET_PASSWORD_SUCCESS });
                return [3 /*break*/, 3];
            case 2:
                err_8 = _a.sent();
                dispatch({ type: actionTypes.RESET_PASSWORD_FAILED });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var savePassword = function (email, token) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.SAVE_PASSWORD_REQUEST });
                return [4 /*yield*/, AuthService.savePassword(email, token)];
            case 1:
                _a.sent();
                dispatch({ type: actionTypes.SAVE_PASSWORD_SUCCESS });
                return [3 /*break*/, 3];
            case 2:
                err_9 = _a.sent();
                dispatch({ type: actionTypes.SAVE_PASSWORD_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var selectApp = function (appId) { return function (dispatch) {
    dispatch({
        type: actionTypes.GO_TO_APP_DETAIL,
        appId: appId,
    });
}; };
export var goToAppDetails = function (appId, platform_version_minor, navigate) { return function (dispatch) {
    dispatch({
        type: actionTypes.GO_TO_APP_DETAIL,
        appId: appId,
    });
    var appLink = "apps/".concat(appId, "/overview");
    switch (platform_version_minor) {
        case (15, 16): {
            appLink = "/apps/".concat(appId, "/overview");
            break;
        }
        default: {
            appLink = "apps/".concat(appId, "/overview");
        }
    }
    navigate(appLink);
}; };
export var goToOrg = function (orgId, navigate) { return function (dispatch) {
    dispatch({
        type: actionTypes.GO_TO_ORG,
        orgId: orgId,
    });
    navigate("/organizations/".concat(orgId));
}; };
export var deleteApp = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: actionTypes.DELETE_APP_REQUEST,
                });
                return [4 /*yield*/, AppService.deleteApp(appId)];
            case 1:
                _a.sent();
                dispatch({ type: actionTypes.DELETE_APP_SUCCESS });
                dispatch(loadApps());
                return [3 /*break*/, 3];
            case 2:
                err_10 = _a.sent();
                dispatch({ type: actionTypes.DELETE_APP_FAILURE, err: err_10 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var setPagination = function (paginationName, paginationIndex) { return function (dispatch) {
    dispatch({
        type: actionTypes.SET_PAGINATION,
        paginationName: paginationName,
        paginationIndex: paginationIndex,
    });
}; };
export var fetchPlatformVersion = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, version, err_11;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: actionTypes.PLATFORM_VERSION_REQUEST });
                return [4 /*yield*/, PlatformService.fetchPlatformVersion()];
            case 1:
                _a = (_b.sent()).object, version = _a === void 0 ? { major: 0, minor: 0, patch: 0 } : _a;
                dispatch({ type: actionTypes.PLATFORM_VERSION_SUCCESS, version: version });
                return [3 /*break*/, 3];
            case 2:
                err_11 = _b.sent();
                console.error(err_11);
                dispatch({ type: actionTypes.PLATFORM_VERSION_FAILURE, err: err_11 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var checkCustomerCardSignup = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payment_method, e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PaymentModal/CARD_CHECK_REQUEST' });
                return [4 /*yield*/, OrganizationService.checkCardSignup()];
            case 1:
                payment_method = (_a.sent()).object;
                dispatch({
                    type: 'PaymentModal/CARD_CHECK_SUCCESS',
                    action: payment_method,
                });
                return [3 /*break*/, 3];
            case 2:
                e_8 = _a.sent();
                console.error(e_8);
                dispatch({ type: 'PaymentModal/CARD_CHECK_FAILURE' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var setAppOpen = function (lastUrl, appId) {
    if (lastUrl === void 0) { lastUrl = '/apps'; }
    return function (dispatch) {
        dispatch({ type: SET_OPEN_APP, payload: { lastUrl: lastUrl, appId: appId } });
    };
};
export var setAppClose = function () { return function (dispatch) {
    dispatch({ type: SET_OPEN_APP, payload: { lastUrl: '/apps', appId: null } });
}; };
export var setToken = function (token) { return storageService.setItem('token', token); };
export var setModalVisibilityOverride = function (override) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (override) {
            dispatch({
                type: actionTypes.SET_MODAL_VISIBILITY_OVERRIDE,
                override: override,
            });
        }
        else {
            dispatch({
                type: actionTypes.SET_MODAL_VISIBILITY_OVERRIDE,
                override: override,
            });
        }
        return [2 /*return*/];
    });
}); }; };
export var setShowModals = function (override) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: actionTypes.SET_MODAL_VISIBILITY_OVERRIDE,
            override: override,
        });
        return [2 /*return*/];
    });
}); }; };
export var setMainSidebarState = function (state) { return function (dispatch) {
    dispatch({
        type: actionTypes.SET_MAIN_SIDEBAR_STATE,
        state: state,
    });
}; };
export var setSearchString = function (searchString) { return function (dispatch) {
    dispatch({
        type: actionTypes.SET_SEARCH_STRING,
        searchString: searchString,
    });
}; };
export var updateOrgType = function (orgId, orgType) { return function (dispatch) {
    dispatch({
        type: actionTypes.UPDATE_ORG_TYPE,
        orgId: orgId,
        orgType: orgType,
    });
}; };
export var updateFavourite = function (orgId, appId, isFavourite) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var result, e_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, AppService.updateFavourite(orgId, appId, isFavourite)];
            case 1:
                result = _a.sent();
                if (result) {
                    dispatch({
                        type: actionTypes.UPDATE_APP_FAVOURITE,
                        appId: appId,
                        isFavourite: isFavourite,
                    });
                    return [2 /*return*/, appId];
                }
                return [3 /*break*/, 3];
            case 2:
                e_9 = _a.sent();
                console.error(e_9);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
